var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadPicture = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1011 0.333984L8.28668 3.96287H3.93202C2.12265 3.96287 0.666016 5.41951 0.666016 7.22887V18.8413C0.666016 20.6507 2.12265 22.1073 3.93202 22.1073H23.528C25.3374 22.1073 26.794 20.6507 26.794 18.8413V7.22887C26.794 5.41951 25.3374 3.96287 23.528 3.96287H19.1733L17.3589 0.333984H10.1011ZM13.73 7.95465C16.5359 7.95465 18.8105 10.2292 18.8105 13.0351C18.8105 15.841 16.5359 18.1155 13.73 18.1155C10.9242 18.1155 8.64957 15.841 8.64957 13.0351C8.64957 10.2292 10.9242 7.95465 13.73 7.95465Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadPicture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/uploadPicture.3e9bbc55d1904b105b8ae93832b19664.svg";